import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/foursquare': {
    width: 368,
    height: 512,
    paths: [
      {
        d: 'M323.1 3H49.9C12.4 3 0 31.3 0 49.1V482.9C0 503.2 12.1 510.6 18.2 513 24.4 515.5 41 517.6 51.1 505.9 180 356.5 182.2 354 182.2 354 185.3 350.6 185.6 350.9 189 350.9H272.4C307.5 350.9 313 325.7 316.7 311.2L365.3 68.2C373.8 25.8 363.1 3 323.1 3zM306.8 76.8L295.4 136.5C294.2 143 285.9 149.7 278.5 149.7H172.1C160.1 149.7 151.5 158 151.5 170V183C151.5 195 160.1 203.6 172.1 203.6H262.5C270.8 203.6 279.1 212.8 277.3 221.8 275.5 230.7 266.8 275.6 265.9 280.6 265 285.5 259.1 294.1 249 294.1H175.5C162 294.1 158.3 295.9 149 306.7 149 306.7 140.1 318.1 59.5 415 58.6 415.9 57.7 415.6 57.7 414.7V75.9C57.7 68.2 64.5 59.3 74.3 59.3H293.3C301.5 59.3 308.9 67 306.8 76.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/foursquare.js
// module id = US0s
// module chunks = 144